import { api, formatParams, config } from "./axios.js";
// export function getIdcsList() {
//   return axios.get('/api/idcs/')
//  }
//  export function getPaginationList(params) {
//   return axios.post(`/list?page=${params.page}`)


export default {
    // 阳光购销列表
    sunshineList: function(params) {
        return api(
            Object.assign(formatParams("POST", params), {
                url: `${config.proxy}/list`
            })
        );
    },
    // 申请入住提交
    SettleInSubmit: function(params) {
        return api(
            Object.assign(formatParams("POST", params), {
                url: `${config.proxy}/add`
            })
        );
    },
};

//阳光购销列表
// export const sunshineList = params => {
//     return axios.post(`${healthURI}/list`, {});
// }